/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Index.jsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/

// Imports MUI Components
import {
  Box,
} from "@mui/material"

// Import Organisms
import HomepageHeader from "../../components/UI/organisms/header/Header"
import Footer from "../../components/UI/organisms/footer/Footer"
import Body from "../../components/UI/organisms/body/contact/Body"
import SplashScreen from "../../components/UI/atoms/splash/SplashScreen"

import { getAuth } from "firebase/auth";

import { useState, useEffect } from "react";

const Contact = () => {

  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    setShowCustomAlert(true);

    const timeout = setTimeout(() => {
      const user = auth.currentUser;
      const userId = user?.uid;
      if (!userId) {
        setShowCustomAlert(false);
      } else {
        setShowCustomAlert(false);
      }
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  const boxStylesWrapper = {
    width: "100%",
    backgroundColor: "#FDF9F3",
  }

  return (
    <>
      {/* Content Wrapper */}
      <Box
        sx={boxStylesWrapper}
      >

        <HomepageHeader/>

        <Body/>

        <Footer/>

      </Box>

      <SplashScreen
        isOpen={showCustomAlert}
      />
      
    </>
  )
}

export default Contact;
